import { HttpErrorResponse } from '@angular/common/http';
import { BookrawAppModule } from 'bookraw/app.module';

export const showErrorMessage = (httpError: HttpErrorResponse) => {
  console.log(httpError);
  // apiból kapott hiba
  const error: { message: string, context: { [key: string]: string[] } } = httpError.error;

  // általános hibaüzenet megjelenítése
  BookrawAppModule.showErrorMessage(`ERROR: ${error.message || httpError.message}`);
};
